import * as React from 'react';
import { useSelector } from 'react-redux';
import { artikelEigenschaftenSelector } from 'store/lookups/selector';
import { requestArtikelEigenschaften } from 'store/lookups/actions';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { DefaultButton, Dialog, DialogFooter, DialogType, Fabric, PrimaryButton } from '@fluentui/react';
import { viewStyles } from 'styles/viewStyles';
import { formStyles } from 'styles/formStyles';
import { FormTextField } from 'formComponents/FormTextField';
import { SavingState } from 'api/savingState';
import {
    addArtikelEigenschaft,
    defaultArtikelEigenschaft,
    ArtikelEigenschaft,
    updateArtikelEigenschaft,
} from 'api/artikelEigenschaft';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { Select } from 'formComponents/Select/Select';
import { Label } from '@fluentui/react/lib/Label';

const styles = mergeStyleSets({
    container: {
        position: 'relative',
        height: 'calc(100vh - 120px)',
        display: 'grid',
        gridTemplateRows: 'max-content 1fr',
        gridRowGap: 10,
    },
    searchBar: {
        display: 'grid',
        gridTemplateColumns: '1fr max-content',
        gridColumnGap: 10,
        marginTop: 10,
    },
});

const groupOptions: SelectOption[] = [
    { value: 'M', label: 'M' },
    { value: 'VF', label: 'VF' },
];

export const ArtikelEigenschaften: React.FC = () => {
    const artikelEigenschaften = useSelector(artikelEigenschaftenSelector);

    const [editData, setEditData] = React.useState<ArtikelEigenschaft | null>(null);

    const save = async () => {
        if (!editData) {
            return;
        }
        if (editData?.eigenschaftNr === -1) {
            await addArtikelEigenschaft(editData);
        } else {
            await updateArtikelEigenschaft(editData);
        }
        await requestArtikelEigenschaften();
        setEditData(null);
    };

    return (
        <Fabric className={styles.container}>
            <div className={styles.searchBar}>
                <div />

                <PrimaryButton
                    onClick={() => setEditData({ ...defaultArtikelEigenschaft, eigenschaftNr: -1 })}
                    text="Neu"
                />
            </div>
            <div className={viewStyles.listContainerScroll}>
                <table className={formStyles.lookupTable}>
                    <thead className={formStyles.lookupTableHead}>
                        <tr>
                            <td className={formStyles.lookupTableCell}>Gruppe</td>
                            <td className={formStyles.lookupTableCell}>Text</td>
                            <td className={formStyles.lookupTableCell} />
                        </tr>
                    </thead>
                    <tbody className={formStyles.lookupTableBody}>
                        {artikelEigenschaften.map((artikelEigenschaft) => (
                            <tr key={artikelEigenschaft.eigenschaftNr} className={formStyles.looupTableRow}>
                                <td className={formStyles.lookupTableCell}>{artikelEigenschaft.eigenschaftKz}</td>
                                <td className={formStyles.lookupTableCell}>{artikelEigenschaft.text}</td>
                                <td className={formStyles.lookupTableActionCell}>
                                    <DefaultButton
                                        className={formStyles.lookupTableEditButton}
                                        onClick={() => setEditData({ ...artikelEigenschaft })}
                                        text="Bearbeiten"
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {editData && (
                <Dialog
                    hidden={false}
                    minWidth={800}
                    dialogContentProps={{
                        title: 'Bearbeiten',
                        type: DialogType.normal,
                    }}
                >
                    <Label>Gruppe</Label>
                    <Select
                        name="Gruppe"
                        value={{ value: editData.eigenschaftKz, label: editData.eigenschaftKz }}
                        options={groupOptions}
                        isDisabled={editData.eigenschaftNr !== -1}
                        onChange={(newValue: ValueType<SelectOption, false>): void => {
                            if (newValue) {
                                setEditData({
                                    ...editData,
                                    eigenschaftKz: newValue.value,
                                });
                            }
                        }}
                    />
                    <FormTextField
                        value={editData.text}
                        savingState={SavingState.notChanged}
                        options={{}}
                        onChange={(newValue): void => {
                            if (editData) {
                                setEditData({
                                    ...editData,
                                    text: newValue as string,
                                });
                            }
                        }}
                        label="Name"
                    />
                    <DialogFooter>
                        <DefaultButton onClick={() => setEditData(null)} text="Abbruch" />
                        <PrimaryButton onClick={save} text="Speichern" />
                    </DialogFooter>
                </Dialog>
            )}
        </Fabric>
    );
};
